import { render, staticRenderFns } from "./CategoryMovement.vue?vue&type=template&id=65d330a8&scoped=true&"
import script from "./CategoryMovement.vue?vue&type=script&lang=js&"
export * from "./CategoryMovement.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMovement.vue?vue&type=style&index=0&id=65d330a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d330a8",
  null
  
)

export default component.exports